import React from "react";
import { MainText, MainTitle } from "app/components/common";
import AnimatedBox from "app/components/common/AnimatedBox";
import i18n from "@microdoing/shared/i18n";
import { StyleSheet, View, Text } from "react-native";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import { connect } from "react-redux";
import {
  getSessions,
  getTotalSessionsDone,
} from "@microdoing/shared/services/coaching/selectors";
import moment from "moment";
import Theme from "@microdoing/shared/constants/Theme";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import theme from "app/Theme/Theme";

const PADDING_HORIZONTAL = 30;
const MARGIN = 5;

const styles = StyleSheet.create({
  main: {
    width: wp("90%"),
  },
  topView: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  sessions: {
    color: theme.colors["neutral.900"],
    fontWeight: "600",
  },
  sessionBar: {
    height: 5,
    backgroundColor: "#F2F2F2",
    borderRadius: 25,
  },
  sessionDone: {
    backgroundColor: theme.colors["brand.500"],
  },
  sessionsBarView: {
    marginTop: 25,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  nextCoachingView: {
    marginTop: 20,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  date: {
    flex: 1,
    alignSelf: "flex-end",
    textAlign: "right",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    fontSize: Theme.FONT_SIZE_MEDIUM,
    color: theme.colors["brand.500"],
  },
});

const CoachingTimeline = ({
  coachingSessions = [],
  coachingSessionsDone = 2,
  language,
}) => {
  const numberOfCoachingSessions = coachingSessions.length;
  const sessionWidth =
    (wp("90%") - PADDING_HORIZONTAL - (numberOfCoachingSessions - 1) * MARGIN) /
    numberOfCoachingSessions;

  const nextCoaching = coachingSessions.find(el => !el.isDone);
  const { nextDate } = nextCoaching ?? {};

  return (
    <AnimatedBox style={styles.main}>
      <View style={styles.topView}>
        <MainTitle variant="l3-bold">{i18n.t("sessions")}</MainTitle>
        <MainText
          variant="l3-semibold"
          textAlign="right"
        >{`${coachingSessionsDone}/${numberOfCoachingSessions}`}</MainText>
      </View>
      <View style={styles.sessionsBarView}>
        {coachingSessions.map((el, index) => {
          const isDone = index + 1 <= coachingSessionsDone;
          return (
            <View
              key={index}
              style={[
                styles.sessionBar,
                { width: sessionWidth },
                isDone && styles.sessionDone,
              ]}
            />
          );
        })}
      </View>
      <View style={styles.nextCoachingView}>
        <MainText>{i18n.t("next-coaching")}</MainText>
        {!!nextDate && (
          <MainText textAlign="right" color="brand.500">
            {moment(nextDate).locale(language).format("dddd D MMMM - H:mm")}{" "}
          </MainText>
        )}
      </View>
    </AnimatedBox>
  );
};

const mapStateToProps = state => {
  return {
    coachingSessions: getSessions(state),
    coachingSessionsDone: getTotalSessionsDone(state),
    language: getLanguage(state),
  };
};

export default connect(mapStateToProps, {})(CoachingTimeline);
